import { useState } from "react";
import { HashRouter, Routes, Route } from "react-router-dom";
import userContext from "./Context";

import Navbar from "./Navbar";
import Home from "./Home";
import Create from "./Create";
import Deposite from "./Deposite";
import Withdraw from "./Withdraw";
import Alldata from "./Alldata";
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/css/bootstrap.min.css';



function App() {

  const [users, setUsers] = useState([]);
  const [total, setTotal] = useState(0);

  return (
    <HashRouter>
      <userContext.Provider value={{ users, setUsers, total, setTotal }}>
        <Navbar />
        <Routes>
          <Route path="/Home" element={<Home />} />
          <Route path="/Create" element={<Create />} />
          <Route path="/Deposite" element={<Deposite />} />
          <Route path="/Withdraw" element={<Withdraw />} />
          <Route path="/Alldata" element={<Alldata />} />
        </Routes>
      </userContext.Provider>
    </HashRouter>
  );
}

export default App;
